export const BULK_DEFAULTS_TEXT =
  'Set the values for Mobile Advertising ID and Cachebuster for all pixels.';
